<div class="main-content">
  <div class="container header-container">
    <div class="half-container">
      <p class="title">{{ 'STATUS_CCTV_TITLE' | translate }}</p>
      <p class="subtitle">{{ 'STATUS_CCTV_SUB_TITLE' | translate }}</p>
    </div>
  </div>


  <div class="card-container">
    <div class="card">
      <div class="imageCard">
        <img src="/assets/images/stattusCCTV/total_cameras.png" alt="Imagen">
      </div>
      <div class="card-body">
        <div>
          <p class="card-title">{{ "TOTAL_CAMERAS" | translate }}</p>
        </div>
        <div>
          <!--  modelIncident.redZoneTotal -->
          <p class="card-text">{{ statusCCTVModel.cameras }}</p>
        </div>
        <div>
          <p class="cardSubText">{{ "TOTAL_CAMERAS_DESCRIPTION" | translate }}</p>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="imageCard">
        <img src="/assets/images/stattusCCTV/visibility.png" alt="Imagen">
      </div>

      <div class="card-body">
        <div>
          <p class="card-title">{{ "VISIBILITY" | translate }}</p>
        </div>
        <div>
          <!--  modelIncident.redZoneTotal -->
          <p class="card-text">{{ statusCCTVModel.visibility }}</p>
        </div>
        <div>
          <p class="cardSubText">{{ "VISIBILITY_DESCRIPTION" | translate }}</p>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="imageCard">
        <img src="/assets/images/stattusCCTV/connected_cameras.png" alt="Imagen">
      </div>

      <div class="card-body">
        <div>
          <p class="card-title">{{ "CONNECTED_CAMERAS" | translate }}</p>
        </div>
        <div>
          <!--  modelIncident.redZoneTotal -->
          <p class="card-text">{{ statusCCTVModel.camerasConnectedPercentage }}%</p>
        </div>
        <div>
          <p class="cardSubText">{{ "CONNECTED_CAMERAS_DESCRIPTION" | translate }}</p>
        </div>
      </div>
    </div>

    <div class="card" >
      <div class="imageCard">
        <img src="/assets/images/stattusCCTV/pcs_with_i4.png" alt="Imagen">
      </div>
      <div class="card-body">
        <div>
          <p class="card-title">{{ "PCS_I4" | translate }}</p>
        </div>
        <div>
          <!--  modelIncident.redZoneTotal -->
          <p class="card-text">{{ statusCCTVModel.pcs }}</p>
        </div>
        <div>
          <p class="cardSubText">{{ "PCS_I4_DESCRIPTION" | translate }}</p>
        </div>
      </div>
    </div>

    <div class="card" >
      <div class="imageCard">
        <img src="/assets/images/stattusCCTV/pc_connections.png" alt="Imagen">
      </div>
      <div class="card-body">
        <div>
          <p class="card-title">{{ "PCS_CONNECTION" | translate}}</p>
        </div>
        <div>
          <!--  modelIncident.redZoneTotal -->
          <p class="card-text">{{ statusCCTVModel.pcsConnectedPercentage }}%</p>
        </div>
        <div>
          <p class="cardSubText">{{ "PCS_CONNECTION_DESCRIPTION" | translate }}</p>
        </div>
      </div>
    </div>

  </div>

  <!-- <button mat-raised-button color="primary" (click)="GetSelectedData()">Get Selected Data</button> -->
  <!-- <button mat-raised-button (click)="showModal()">Toggle drawer</button> -->

  <!-- [Data]="arrayGirdControlTower" [IconColumn]="iconColumn"  -->
  <!-- [HiddenColumns]="''"  -->
  <!-- (cellClickEvent)="cellClick($event)"  [Filter]="gFilter" -->
  <neoris-grid [ColumnsConfiguration]="gridColumnsConfiguration" [GridTitle]="gridTitle" [ShowChecks]="false"
    [Data]="gridData" (cellClickEvent)="cellClick($event)"></neoris-grid>
</div>